module.exports = __webpack_public_path__ + "static/media/career_coaching_ad.67fe0add.png";